/* eslint-disable react/no-array-index-key */
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import {
  Avatar,
  FormControl,
  InputLabel,
  List,
  ListItem,
  ListItemText,
  MenuItem,
  Select,
} from '@material-ui/core';

import { defineMessages, FormattedMessage } from 'react-intl';

import { KeyboardDatePicker, KeyboardTimePicker } from '@material-ui/pickers';
import styles from '../../styles.module.css';
import * as actions from '../../../../../state';
import { selectLayout } from '../../../../../state';

const supportedRanges = [{
  labelId: 'ONE_HOUR',
  value: '1_hour',
}, {
  labelId: 'TWO_HOUR',
  value: '2_hour',
}, {
  labelId: 'EIGHT_HOUR',
  value: '8_hour',
}, {
  labelId: 'ONE_DAY',
  value: '1_day',
}, {
  labelId: 'TWO_DAY',
  value: '2_day',
}, {
  labelId: 'ONE_WEEK',
  value: '7_day',
}, {
  labelId: 'TWO_WEEK',
  value: '2_week',
}, {
  labelId: 'ONE_MONTH',
  value: '4_week',
},
// , {
//   labelId: 'TWO_MONTH',
//   value: '2_month',
// }, {
//   labelId: 'THREE_MONTH',
//   value: '3_month',
// }, {
//   labelId: 'SIX_MONTH',
//   value: '6_month',
// }, {
//   labelId: 'ONE_YEAR',
//   value: '1_year',
// }
];

const messages = defineMessages({
  TIME: {
    id: 'TIME',
    defaultMessage: 'Time',
  },

  // controls
  TIME_RANGE_TYPE: {
    id: 'TIME_RANGE_TYPE',
    defaultMessage: 'Type',
  },
  TIME_RANGE: {
    id: 'TIME_RANGE',
    defaultMessage: 'Time Range',
  },

  // type options
  ROLLING: {
    id: 'ROLLING',
    defaultMessage: 'Rolling',
  },
  STATIC: {
    id: 'STATIC',
    defaultMessage: 'Static',
  },
  DAILY: {
    id: 'DAILY',
    defaultMessage: 'Daily',
  },

  // range options
  ONE_HOUR: {
    id: 'ONE_HOUR',
    defaultMessage: '1 Hour',
  },
  TWO_HOUR: {
    id: 'TWO_HOUR',
    defaultMessage: '2 Hours',
  },
  EIGHT_HOUR: {
    id: 'EIGHT_HOUR',
    defaultMessage: '8 Hours',
  },
  ONE_DAY: {
    id: 'ONE_DAY',
    defaultMessage: '24 Hours',
  },
  TWO_DAY: {
    id: 'TWO_DAY',
    defaultMessage: '48 Hours',
  },
  ONE_WEEK: {
    id: 'ONE_WEEK',
    defaultMessage: '7 Days',
  },
  TWO_WEEK: {
    id: 'TWO_WEEK',
    defaultMessage: '14 Days',
  },
  ONE_MONTH: {
    id: 'ONE_MONTH',
    defaultMessage: '1 Month',
  },
  TWO_MONTH: {
    id: 'TWO_MONTH',
    defaultMessage: '2 Months',
  },
  THREE_MONTH: {
    id: 'THREE_MONTH',
    defaultMessage: '3 Months',
  },
  SIX_MONTH: {
    id: 'SIX_MONTH',
    defaultMessage: '6 Months',
  },
  ONE_YEAR: {
    id: 'ONE_YEAR',
    defaultMessage: '12 Months',
  },

  // static options
  START_DATE: {
    id: 'START_DATE',
    defaultMessage: 'Start Date',
  },
  START_TIME: {
    id: 'START_TIME',
    defaultMessage: 'Start Time',
  },
  END_DATE: {
    id: 'END_DATE',
    defaultMessage: 'End Date',
  },
  END_TIME: {
    id: 'END_TIME',
    defaultMessage: 'End Time',
  },
});

function TimeRange({
  handleDailyDayToggle,
  handleDailyTimeChange,
  handleDateInput,
  handleRangeSelect,
  handleRangeTypeSelect,
  timeRange,
}) {
  const layout = useSelector(selectLayout);
  const [startAmPm, setStartAmPm] = useState('AM');
  const [endAmPm, setEndAmPm] = useState('AM');
  
  // Time format configurations
  const time12HourFormat = useSelector(
    (state) => actions.selectConfig(state, 'PORTAL_LOCALIZATION_TIME_12_HOUR_FORMAT') || 'yes',
  );
  const timeDelimiter = useSelector(
    (state) => actions.selectConfig(state, 'PORTAL_LOCALIZATION_TIME_DELIMITER') || ':',
  );
  const portalTimeFormat = useSelector(
    (state) => actions.selectConfig(state, 'PORTAL_LOCALIZATION_TIME_FORMAT') || 'HMS',
  );
  const timeFormatMaster = useSelector(
    (state) => actions.selectConfig(state, 'PORTAL_LOCALIZATION_TIME_FORMAT_MASTER') || 'yes',
  );
  
  // Date format configurations
  const dateFormat = useSelector(
    (state) => actions.selectConfig(state, 'PORTAL_LOCALIZATION_DATE_FORMAT') || 'MDY',
  );
  const dateDelimiter = useSelector(
    (state) => actions.selectConfig(state, 'PORTAL_LOCALIZATION_DATE_DELIMITER') || '/',
  );
  const datetimeDelimiter = useSelector(
    (state) => actions.selectConfig(state, 'PORTAL_LOCALIZATION_DATETIME_DELIMITER') || ' ',
  );
  const dateFormatMaster = useSelector(
    (state) => actions.selectConfig(state, 'PORTAL_LOCALIZATION_DATE_FORMAT_MASTER') || 'yes',
  );
  
  const use12HourFormat = !((timeFormatMaster.toLowerCase() === 'yes' && time12HourFormat.toLowerCase() === 'no'));

  useEffect(() => {
    const startDate = new Date(timeRange.start_date);
    const startHours = startDate.getHours();
    setStartAmPm(startHours >= 12 ? 'PM' : 'AM');
    
    const endDate = new Date(timeRange.end_date);
    const endHours = endDate.getHours();
    setEndAmPm(endHours >= 12 ? 'PM' : 'AM');
  }, [timeRange.start_date, timeRange.end_date]);
  
  const getTimeFormat = () => {
    if (timeFormatMaster.toLowerCase() === 'no') return 'hh:mm';

    const hourFormat = use12HourFormat ? 'hh' : 'HH';
    let newTimeFormat;
    if (portalTimeFormat.toUpperCase() === 'SMH') {
      newTimeFormat = `mm${timeDelimiter}${hourFormat}`;
    } else {
      newTimeFormat = `${hourFormat}${timeDelimiter}mm`;
    }
    return newTimeFormat;
  };
  
  const getDateFormat = () => {
    const timeFormat = getTimeFormat();
    if (dateFormatMaster.toLowerCase() === 'no') return `MM/DD/YYYY ${timeFormat}`;

    let newDateFormat;
    if (dateFormat.toUpperCase() === 'DMY') {
      newDateFormat = `DD${dateDelimiter}MM${dateDelimiter}YYYY`;
    } else if (dateFormat.toUpperCase() === 'YMD') {
      newDateFormat = `YYYY${dateDelimiter}MM${dateDelimiter}DD`;
    } else {
      newDateFormat = `MM${dateDelimiter}DD${dateDelimiter}YYYY`;
    }
    return `${newDateFormat}${datetimeDelimiter}${timeFormat}`;
  };

  const dayIntToChar = (dayInt) => {
    // TODO: put some localization magic here
    switch (dayInt) {
      case 0:
      case 6:
        return 'S';
      case 1:
        return 'M';
      case 2:
      case 4:
        return 'T';
      case 3:
        return 'W';
      case 5:
        return 'F';
      default:
        return '';
    }
  };

  const daytimeConfigToDatetime = (timeConfig) => {
    const now = new Date();
    now.setHours(timeConfig.h, timeConfig.m);
    return now;
  };

  if (!timeRange) { // the time range component can't work if there's no time range prop provided
    return '';
  }

  const handleAmPmChange = (event, dateParam) => {
    const newAmPm = event.target.value;
    if (dateParam === 'start_date') {
      setStartAmPm(newAmPm);
    } else {
      setEndAmPm(newAmPm);
    }
    
    const date = new Date(timeRange[dateParam]);
    const currentHours = date.getHours();
    
    if (newAmPm === 'PM' && !(currentHours >= 12)) {
      if (currentHours !== 12) {
        date.setHours(currentHours + 12);
      }
    } else if (newAmPm === 'AM' && (currentHours >= 12)) {
      if (currentHours !== 12) {
        date.setHours(currentHours - 12);
      } else {
        date.setHours(0);
      }
    }
    
    handleDateInput(date, dateParam);
  };

  const rangeType = timeRange.type || 'rolling';
  const timeFormat = getTimeFormat();
  const dateTimeFormat = getDateFormat();

  return (
    <List dense className={styles.menu}>
      <ListItem className={styles.menuItemHeader} style={{ fontSize: '0.8125rem !important' }}>
        <ListItemText
          primary={<FormattedMessage {...messages.TIME} />}
        />
      </ListItem>

      <ListItem>
        <FormControl className={styles.selectControl}>
          <InputLabel shrink htmlFor="time_range_type">
            <FormattedMessage {...messages.TIME_RANGE_TYPE} />
          </InputLabel>

          <Select
            displayEmpty
            inputProps={{ id: 'time_range_type' }}
            style={{ width: '100%' }}
            value={rangeType || 'rolling'}
            onChange={handleRangeTypeSelect}
            classes={{
              select: styles.sideSheetSelect,
            }}
          >
            <MenuItem key="rolling" value="rolling">
              <FormattedMessage {...messages.ROLLING} />
            </MenuItem>

            <MenuItem key="static" value="static">
              <FormattedMessage {...messages.STATIC} />
            </MenuItem>

            <MenuItem key="daily" value="daily">
              <FormattedMessage {...messages.DAILY} />
            </MenuItem>
          </Select>
        </FormControl>
      </ListItem>

      { rangeType === 'rolling'
        && (
          <>
            <ListItem>
              <FormControl className={styles.selectControl}>
                <InputLabel shrink htmlFor="time_range">
                  <FormattedMessage {...messages.TIME_RANGE} />
                </InputLabel>

                <Select
                  displayEmpty
                  id="time_range"
                  onChange={handleRangeSelect}
                  value={timeRange.range || timeRange || '1_day'}
                  classes={{
                    select: styles.sideSheetSelect,
                  }}
                >
                  {supportedRanges.map((range, index) => (
                    <MenuItem
                      key={`timerange_${index}`}
                      value={range.value}
                    >
                      <FormattedMessage {...messages[range.labelId]} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </ListItem>
          </>
        )}

      { rangeType === 'static'
        && (
          <>
            <ListItem>
              <KeyboardDatePicker
                variant="inline"
                label={<FormattedMessage {...messages.START_DATE} />}
                format={dateTimeFormat}
                value={new Date(timeRange.start_date)}
                onChange={(moment) => {
                  if (moment?.isValid()) {
                    if (use12HourFormat) {
                      const newDate = moment.toDate();
                      const newHours = newDate.getHours();
                      const currentDate = new Date(timeRange.start_date);
                      
                      if (currentDate.getHours() >= 12) {
                        if (newHours < 12) {
                          newDate.setHours(newHours + 12);
                        } else if (newHours >= 12) {
                          newDate.setHours(newHours);
                        }
                      }
                      handleDateInput(newDate, 'start_date');
                    } else {
                      handleDateInput(moment, 'start_date');
                    }
                  }
                }}
                style={{ width: use12HourFormat ? '80%' : '100%' }}
                allowKeyboardControl
                animateYearScrolling
                autoOk
                disableMaskedInput
                InputAdornmentProps={{ position: 'end' }}
              />
              {use12HourFormat && (
                <Select
                  value={startAmPm}
                  onChange={(event) => handleAmPmChange(event, 'start_date')}
                  style={{ width: '20%', marginTop: '16px' }}
                >
                  <MenuItem value="AM">AM</MenuItem>
                  <MenuItem value="PM">PM</MenuItem>
                </Select>
              )}
            </ListItem>

            <ListItem>
              <KeyboardDatePicker
                variant="inline"
                label={<FormattedMessage {...messages.END_DATE} />}
                format={dateTimeFormat}
                value={new Date(timeRange.end_date)}
                onChange={(moment) => {
                  if (moment?.isValid()) {
                    if (use12HourFormat) {
                      const newDate = moment.toDate();
                      const newHours = newDate.getHours();
                      const currentDate = new Date(timeRange.end_date);
                      
                      if (currentDate.getHours() >= 12) {
                        if (newHours < 12) {
                          newDate.setHours(newHours + 12);
                        } else if (newHours >= 12) {
                          newDate.setHours(newHours);
                        }
                      }             
                      handleDateInput(newDate, 'end_date');
                    } else {
                      handleDateInput(moment, 'end_date');
                    }
                  }
                }}
                style={{ width: use12HourFormat ? '80%' : '100%' }}
                allowKeyboardControl
                animateYearScrolling
                autoOk
                disableMaskedInput
                InputAdornmentProps={{ position: 'end' }}
              />
              {use12HourFormat && (
              <Select
                value={endAmPm}
                onChange={(event) => handleAmPmChange(event, 'end_date')}
                style={{ width: '20%', marginTop: '16px' }}
              >
                <MenuItem value="AM">AM</MenuItem>
                <MenuItem value="PM">PM</MenuItem>
              </Select>
              )}
            </ListItem>
          </>
        )}

      {rangeType === 'daily' && (
        <>
          <ListItem>
            {timeRange.daytimes.map((daytime) => (
              <Avatar
                key={`day-${daytime.day}`}
                onClick={() => handleDailyDayToggle(daytime.day)}
                className={`${styles.dayToggle}`}
                style={{ backgroundColor: daytime.active ? layout.brandPrimaryColor : '#bdbdbd' }}
              >
                {dayIntToChar(daytime.day)}
              </Avatar>
            ))}
          </ListItem>

          <ListItem>
            <FormControl className={styles.timePickerControl}>
              <KeyboardTimePicker
                variant="inline"
                label={<FormattedMessage {...messages.START_TIME} />}
                format={use12HourFormat ? `${timeFormat} A` : timeFormat}
                value={daytimeConfigToDatetime(timeRange.daytimes[0].start_time)}
                onChange={(moment) => {
                  if (moment?.isValid()) {
                    handleDailyTimeChange(moment, 'start_time');
                  }
                }}
                InputAdornmentProps={{ position: 'end' }}
                autoOk
                disableMaskedInput
              />
            </FormControl>

            <div className={styles.toSpacer}>to</div>

            <FormControl className={styles.timePickerControl}>
              <KeyboardTimePicker
                variant="inline"
                label={<FormattedMessage {...messages.END_TIME} />}
                format={use12HourFormat ? `${timeFormat} A` : timeFormat}
                value={daytimeConfigToDatetime(timeRange.daytimes[0].end_time)}
                onChange={(moment) => {
                  if (moment?.isValid()) {
                    handleDailyTimeChange(moment, 'end_time');
                  }
                }}
                InputAdornmentProps={{ position: 'end' }}
                autoOk
                disableMaskedInput
              />
            </FormControl>
          </ListItem>
        </>
      )}
    </List>
  );
}

export default TimeRange;
